export const setCurrentRoute = (route) => ({
  type: 'SET_CURRENT_ROUTE',
  route,
});

export const resetCurrentRoute = () => ({
  type: 'RESET_CURRENT_ROUTE',
});
